import variables from "../styles/variables/exportedVars.module.scss";

const { primaryFont } = variables;

export const THEME_OPTIONS = {
  fontFamily: primaryFont,
};
